// packages/shared-versioning/src/useVersionCheck.ts
import { useEffect, useState } from "react";
import { APP_VERSION } from "./version";
export function useVersionCheck(pollMs = 500000) {
    const [isStale, setIsStale] = useState(false);
    const [latest, setLatest] = useState(null);
    useEffect(() => {
        let cancelled = false;
        async function check() {
            try {
                const res = await fetch("/version.json", {
                    cache: "no-store",
                });
                if (!res.ok) {
                    return;
                }
                const data = (await res.json());
                if (cancelled) {
                    return;
                }
                setLatest(data);
                if (data.version && data.version !== APP_VERSION) {
                    setIsStale(true);
                }
            }
            catch {
                // Optional: log to your error tracking, but fail silently for users.
            }
        }
        // Run immediately, then on interval.
        check();
        const id = setInterval(check, pollMs);
        return () => {
            cancelled = true;
            clearInterval(id);
        };
    }, [pollMs]);
    return {
        isStale,
        latest,
        currentVersion: APP_VERSION,
    };
}
//# sourceMappingURL=useVersionCheck.js.map